import React, { useEffect } from "react"
import { compose } from "redux"

// Components
import RecordLeadsData from "../RecordLeadsData"
import ConclusionSection from "../ConclusionSection"
import GeneralInfoSection from "../GeneralInfoSection"
import SignalsCanvasContainer from "../SignalsCanvasContainer"
import CommonParametersSection from "../CommonParametersSection"
import DropdownSection from "../DropdownSection"

// Styles
import useStyles from "./styles"
import ECGGraph from "../ECGGraph"
import withApproveDialog, { WithApproveDialogProps } from "../../hoc/withApproveDialog";
import withRecordData, { WithRecordDataProps } from "../../hoc/withRecordData";

function RecordDetailsSection(props: WithApproveDialogProps & WithRecordDataProps) {
    const styles = useStyles();
    const { record } = props;

    if (!record) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.info_section}>
                <GeneralInfoSection/>
                <CommonParametersSection/>
                <ConclusionSection/>
            </div>
                <div className={styles.main_section}>

                    <div style={{ "width" : "100%", "overflow" : "auto"}}><ECGGraph/></div>
            </div>
        </div>
    )
}

export default compose(
    withApproveDialog,
    withRecordData,
)(RecordDetailsSection);
